//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCajaChicasSantiagoOF } from "@/typings/store/plugins/easyFirestore/cajaChicasSantiagoOF";

const getters: GetterTree<StateCajaChicasSantiagoOF, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const cajaChicasSantiagoOF = {
    firestorePath: "dev/v1/cajaChicasSantiagoOF",
    firestoreRefType: "collection",
    moduleName: "cajaChicasSantiagoOF",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default cajaChicasSantiagoOF;
